module.exports = __webpack_public_path__ + "img/zoom_in.648b14d7.svg";